import { gql } from '@apollo/client'

export const TEST_SESSIONS = gql`
  query TestSessions(
    $filterData: TestSessionFilterInput
    $groupsInputData: TestSessionGroupsInput
    $companyInputData: TestSessionCompanyInput
    $pagination: PaginationInput!
  ) {
    testSessions(filterData: $filterData, pagination: $pagination) {
      testSessions {
        id
        date
        name
        type
        category
        lab
        isScheduled
        rejectedAt
        finishedAt
        Location {
          id
          street
          city
        }
        Members: Members(inputData: { numOfResulted: true }) {
          isParticipant
          isResulted
        }
        Group {
          id
          name
          japaneseGroup
        }
        Groups(inputData: $groupsInputData) {
          id
          name
          japaneseGroup
        }
        Company(inputData: $companyInputData) {
          id
          name
        }
        paymentStatus
        sublocation
        Invoice {
          invoiceId
          invoiceDocNumber
          invoiceDate
          autoInvoice
        }
      }
      pagination {
        from
        total
        length
      }
    }
  }
`
